<div>
	<div class="c-modal__header">
		<h3 class="c-modal__title">{{ title }}</h3>

		<button
			class="c-login-modal__close-button"
			[ariaLabel]="cancelButton.title"
			[title]="cancelButton.title"
			(click)="close()"
		>
			<fa-icon icon="fa-xmark" iconType="fa-solid"></fa-icon>
		</button>
	</div>

	<div class="c-modal__body" [innerHTML]="text"></div>

	<div class="c-modal__footer c-login-modal__actions">
		@if (confirmButton) {
			<cjm-button
				[classes]="buttonClasses.RegularFullWidth + ' ' + 'c-button--blue'"
				[title]="confirmButton.title"
				(click)="login()"
				>{{ confirmButton.text }}</cjm-button
			>
		}

		@if (cancelButton) {
			<cjm-button
				class="c-modal__action"
				[classes]="buttonClasses.OutlineFullWidth + ' ' + 'c-button--blue-outline'"
				[title]="cancelButton.title"
				(click)="close()"
				>{{ cancelButton.text }}</cjm-button
			>
		}
	</div>
</div>
